// extracted by mini-css-extract-plugin
export default {"stepperLabel":"VerticalStepper_stepperLabel__9wQ6T"};